<div class="admsb-arbol-contenedor">
  <div *ngIf="cargando" class="ds-cargando">
    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
    <span>{{ 'LBL_CARGANDO' | translate }}</span>
  </div>

  <ng-container *ngIf="!cargando">
    <!-- NIVEL 1: SERVICIO -->
    <div class="arbol-servicio" *ngFor="let servicio of servicios">
      <!-- Cabecera Servicio -->
      <div class="arbol-servicio__header" (click)="toggleServicio(servicio)" role="button" tabindex="0">
        <div class="arbol-servicio__header-izq">
          <i class="fa chevron-icon" [ngClass]="servicio.abierto ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          <span class="arbol-servicio__titulo">
            {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_SERVICIO' | translate }} <span class="txt-azul">{{ servicio.nombreServicio }}</span>
          </span>
          <span class="arbol-metrica">
            <i class="fa fa-calendar-o"></i>
            {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ACTIVACION' | translate }} {{ servicio.fechaActivacion }}
          </span>
          <span class="arbol-metrica">
            <i class="fa fa-th-list"></i>
            {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_METODOS' | translate }} {{ servicio.metodosActivosCount }} {{ 'LBL_DE' | translate }} {{ servicio.metodosTotalCount }} {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ACTIVOS' | translate }}
          </span>
          <span class="arbol-metrica">
            <i class="fa fa-money"></i>
            {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MEDIOS' | translate }} {{ servicio.mediosActivosCount }} {{ 'LBL_DE' | translate }} {{ servicio.mediosTotalCount }} {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ACTIVOS' | translate }}
          </span>
        </div>

        <div class="arbol-servicio__header-der" (click)="$event.stopPropagation()">
          <button *ngIf="servicio.codigoEstadoServicio === 'SERACT'" type="button" class="btn-arbol-accion btn-rojo"
                  (click)="bloquearServicio(servicio)">
            <i class="fa fa-lock"></i>
            <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_BLOQUEAR_SERVICIO' | translate }}</span>
          </button>
          <button *ngIf="servicio.codigoEstadoServicio === 'SERBLO'" type="button" class="btn-arbol-accion btn-verde"
                  (click)="desbloquearServicio(servicio)">
            <i class="fa fa-unlock"></i>
            <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_DESBLOQUEAR_SERVICIO' | translate }}</span>
          </button>
        </div>
      </div>

      <!-- Contenido Servicio (Canales) -->
      <div class="arbol-servicio__cuerpo" *ngIf="servicio.abierto">
        <!-- NIVEL 2: CANAL DE USO -->
        <div class="arbol-canal" *ngFor="let canal of servicio.canales">
          <!-- Cabecera Canal -->
          <div class="arbol-canal__header" (click)="toggleCanal(canal)" role="button" tabindex="0">
            <div class="arbol-canal__header-izq">
              <i class="fa chevron-icon" [ngClass]="canal.abierto ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
              <span class="arbol-canal__titulo">
                {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CANAL' | translate }} {{ canal.nombreCanal }}
              </span>
              <span class="arbol-metrica">
                {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_METODOS' | translate }} {{ canal.totalMetodosActivos }} {{ 'LBL_DE' | translate }} {{ canal.totalMetodos }} {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ACTIVOS' | translate }}
              </span>
            </div>
          </div>

          <!-- Contenido Canal (Métodos) -->
          <div class="arbol-canal__cuerpo" *ngIf="canal.abierto">
            <!-- NIVEL 3: MÉTODO DE PAGO -->
            <div class="arbol-metodo" *ngFor="let metodo of canal.metodos">
              <!-- Cabecera Método -->
              <div class="arbol-metodo__header" (click)="toggleMetodo(metodo)" role="button" tabindex="0">
                <div class="arbol-metodo__header-izq">
                  <i class="fa chevron-icon" [ngClass]="metodo.abierto ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                  <span class="arbol-metodo__titulo">{{ metodo.nombreMetodo }}</span>
                  <span class="badge-estado-metodo" [ngClass]="metodo.codigoEstadoMetodo === estadosMetodosMedios.METODOACTIVO ? 'badge-activo' : 'badge-inactivo'">
                    {{ metodo.estadoMetodo }}
                  </span>
                  <span class="arbol-metodo__subtexto">
                    {{ metodo.totalMediosActivos }} {{ 'LBL_DE' | translate }} {{ metodo.totalMedios }} {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MEDIOS_HABILITADOS' | translate }}
                    <ng-container *ngIf="metodo.ultimoUsoFecha">
                      | {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ULTIMO_USO' | translate }}: {{ metodo.ultimoUsoFecha }}
                    </ng-container>
                  </span>
                </div>

                <div class="arbol-metodo__header-der" (click)="$event.stopPropagation()">
                  <button *ngIf="metodo.idAdjuntoCertificadoRegistro" type="button" class="btn-arbol-accion btn-ojo"
                          title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VER_DOCUMENTO' | translate }}"
                          (click)="verDocumentoHabilitacion(metodo)">
                    <i class="fa fa-eye"></i>
                  </button>
                  <button *ngIf="metodo.codigoEstadoMetodo === estadosMetodosMedios.METODOACTIVO" type="button" class="btn-arbol-accion btn-rojo"
                          (click)="bloquearMetodo(metodo)">
                    <i class="fa fa-lock"></i>
                    <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_BLOQUEAR' | translate }}</span>
                  </button>
                  <button *ngIf="metodo.codigoEstadoMetodo !== estadosMetodosMedios.METODOACTIVO" type="button" class="btn-arbol-accion btn-verde"
                          (click)="activarMetodo(metodo)">
                    <i class="fa fa-unlock"></i>
                    <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_ACTIVAR' | translate }}</span>
                  </button>
                </div>
              </div>

              <!-- Contenido Método (NIVEL 4: Medios, Banner, Adjuntos, Contratos) -->
              <div class="arbol-metodo__cuerpo" *ngIf="metodo.abierto">
                <!-- 1. TABLA DE MEDIOS DE PAGO (10 Columnas) -->
                <div class="arbol-tabla-wrapper">
                  <p-table [value]="metodo.medios" styleClass="ds-tabla tabla-medios-arbol" [responsive]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="text-left">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MEDIODEPAGO' | translate }}</th>
                        <th class="text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ESTADO' | translate }}</th>
                        <th class="text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_COMISIONPORVENTA' | translate }}</th>
                        <th class="text-right">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFATRXINDIVIDUAL_COL' | translate }}</th>
                        <th class="text-right">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VENTAMINIMA' | translate }}</th>
                        <th class="text-right">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VENTAMAXIMA' | translate }}</th>
                        <th class="text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_LIMITEDIA_RECAUDOS' | translate }}</th>
                        <th class="text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_LIMITEMES_RECAUDOS' | translate }}</th>
                        <th class="text-right">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_LIMITEMES_MONTO' | translate }}</th>
                        <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-medio>
                      <tr>
                        <td class="text-left font-medium">{{ medio.nombreMedio }}</td>
                        <td class="text-center">
                          <span class="badge-estado-medio"
                                [ngClass]="medio?.codigoEstadoMedio === estadosMetodosMedios.MEDIOACTIVO ? 'badge-activo' : (medio?.codigoEstadoMedio === 'MEDDEN' || medio?.codigoEstadoMedio === 'DENEGA' || medio?.estadoMedio?.toUpperCase() === 'DENEGADO' ? 'badge-denegado' : 'badge-inactivo')">
                            {{ medio.estadoMedio ?? "ADMINISTRADORSERVICIOSBANCARIOS.ESTADOINACTIVO" | translate }}
                          </span>
                        </td>
                        <td class="text-center">{{ medio.tarifaTrxVentaPorcentaje ?? 0 }}%</td>
                        <td class="text-right">{{ medio.tarifaTrxIndividual ?? 0 | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td class="text-right">{{ medio.montoMinimoTrx ?? 0 | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td class="text-right">{{ medio.montoMaximoTrx ?? 0 | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td class="text-center">{{ medio.limiteTrxDiario ?? 0 }}</td>
                        <td class="text-center">{{ medio.limiteTrxMes ?? 0 }}</td>
                        <td class="text-right">{{ medio.montoMaximoMes ?? 0 | currency:'USD':'symbol':'1.0-0' }}</td>
                        <td class="text-center">
                          <div class="acciones-medios-flex">
                            <!-- Ver documento de habilitación -->
                            <button *ngIf="medio.idAdjuntoCertificadoRegistro" type="button" class="btn-icono-sq btn-sq-ojo"
                                    title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_VER_DOCUMENTO' | translate }}"
                                    (click)="verDocumentoHabilitacionMedio(medio, metodo)">
                              <i class="fa fa-eye"></i>
                            </button>
                            <!-- Bloquear (Activo) -->
                            <button *ngIf="medio?.codigoEstadoMedio === estadosMetodosMedios.MEDIOACTIVO" type="button" class="btn-icono-sq btn-sq-rojo"
                                    title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_BLOQUEAR' | translate }}"
                                    (click)="bloquearMedio(medio, metodo)">
                              <i class="fa fa-lock"></i>
                            </button>
                            <!-- Activar (Inactivo / Bloqueado / Denegado) -->
                            <button *ngIf="medio?.codigoEstadoMedio !== estadosMetodosMedios.MEDIOACTIVO" type="button" class="btn-icono-sq btn-sq-verde"
                                    title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_ACTIVAR' | translate }}"
                                    (click)="activarMedio(medio, metodo)">
                              <i class="fa fa-check"></i>
                            </button>
                            <!-- Cambio de tarifas -->
                            <button *ngIf="medio?.codigoEstadoMedio === estadosMetodosMedios.MEDIOACTIVO" type="button" class="btn-icono-sq btn-sq-azul"
                                    title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_CAMBIO_TARIFAS' | translate }}"
                                    (click)="cambioTarifas(medio, metodo)">
                              <i class="fa fa-dollar"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="10" class="text-center msg-vacio">
                          {{ 'MSG_NOHAYREGISTROS' | translate }}
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>

                <!-- 2. BANNER INFORMATIVO DE TARIFAS -->
                <div class="arbol-banner-info">
                  <i class="fa fa-info-circle banner-icono"></i>
                  <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_BANNER_TARIFAS' | translate:{canal: canal.nombreCanal} }}</span>
                </div>

                <!-- 3. SECCIÓN ADJUNTOS -->
                <app-admsb-adjuntos-tabla
                  [idTitular]="idTitular"
                  vista="arbol"
                  [rows]="4"
                  [confirmKey]="'admsb-arbol-adj-' + (metodo.idMetodo || metodo.idTerceroUPPasarelaProducto || metodo.codigoMetodo)"
                  [adjuntosIniciales]="metodo.adjuntos"
                  (adjuntosActualizados)="onAdjuntosActualizados($event, metodo)">
                </app-admsb-adjuntos-tabla>

                <!-- 4. SECCIÓN CONTRATOS -->
                <div class="arbol-seccion-bloque">
                  <div class="arbol-seccion-header">
                    <div class="arbol-seccion-izq">
                      <span class="arbol-seccion-titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATOS' | translate }}</span>
                    </div>
                    <div class="arbol-seccion-der">
                      <span class="p-input-icon-left buscador-seccion">
                        <i class="fa fa-search"></i>
                        <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="metodo.filtroContratos">
                      </span>
                    </div>
                  </div>

                  <p-table [value]="filtrarContratosMetodo(metodo)" [paginator]="true" [rows]="4" styleClass="ds-tabla tabla-contratos-arbol">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="text-left">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATO' | translate }}</th>
                        <th class="text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_FECHAFIRMA' | translate }}</th>
                        <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-c>
                      <tr>
                        <td class="text-left">{{ c.nombrePlantilla || '--' }}</td>
                        <td class="text-center">{{ c.fechaFirma ? (c.fechaFirma | date:'yyyy-MM-dd') : '--' }}</td>
                        <td class="text-center">
                          <button type="button" pButton class="btn-action-premium" icon="fa fa-eye"
                                  title="{{ 'BTN_VISUALIZAR' | translate }}" (click)="previsualizarContrato(c)">
                          </button>
                        </td>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="3" class="text-center msg-vacio">{{ 'MSG_NOHAYREGISTROS' | translate }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Visor de Adjunto (requerido para soporte documental en cabeceras y modal de aprobación HU #5354) -->
<app-p-dialog-adjunto-visor *ngIf="showModalAdjunto" [showModalAdjunto]="showModalAdjunto"
                            header="ARCHIVO ADJUNTO"
                            [loadingFile]="loadingFile"
                            [fileUrl]="fileUrl" [subAdjunto]="subAdjunto" [detalle]="false"
                            [svcThUrl]="adjuntoVisor?.indicadorTercero ? svcThUrlTercero : svcThUrl"
                            (cerrarModalAdjuntoEmit)="cerrarModalAdjunto()"
                            (descargarArchivoEmit)="descargarArchivo()"
                            (onBeforeSendEmit)="onBeforeSendAdjunto($event)"
                            (onSelectEmit)="onSelectAdjunto($event.files, adjuntoVisor)"
                            (onUploadEmit)="onUploadAdjunto($event, adjuntoVisor)">
</app-p-dialog-adjunto-visor>

<!-- Modal Previsualizar Contrato -->
<p-dialog [(visible)]="mostrarModalContrato" [modal]="true" [closable]="true" [draggable]="false"
          [style]="{width: '600px'}" styleClass="ds-dialog" class="footer-center"
          header="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONTRATO' | translate | uppercase }}">
  <div class="admsb-contrato-preview" [innerHTML]="contenidoContrato"></div>
  <ng-template pTemplate="footer">
    <button type="button" pButton class="btn-primary-full" icon="fa fa-close"
            label="{{ 'BTN_CERRAR' | translate }}" (click)="cerrarModalContrato()"></button>
  </ng-template>
</p-dialog>

<!-- Modal Gestión de Aprobación (HU #5354) -->
<p-dialog [(visible)]="mostrarModalAprobacion" [modal]="true" [closable]="true" [draggable]="false"
          [style]="{width: '540px'}" [breakpoints]="{'768px': '92vw'}" styleClass="ds-dialog modal-aprobacion-medio"
          [closeOnEscape]="true" (onHide)="cerrarModalAprobacion()">

  <ng-template pTemplate="header">
    <span class="modal-aprobacion__titulo">
      {{ 'ADMINISTRADORSERVICIOSBANCARIOS.TITULO_MODAL_GESTION_APROBACION' | translate }}
    </span>
  </ng-template>

  <div class="modal-aprobacion__contenido" *ngIf="medioParaAprobacion || metodoParaAprobacion">
    <!-- Tarjeta destacada verde tenue con el medio o método seleccionado -->
    <div class="modal-aprobacion__tarjeta-medio">
      <div class="modal-aprobacion__tarjeta-icono">
        <i [class]="medioParaAprobacion ? 'fa fa-credit-card' : 'fa fa-th-large'"></i>
      </div>
      <span class="modal-aprobacion__tarjeta-nombre">
        {{ medioParaAprobacion ? (medioParaAprobacion.nombreMedio || medioParaAprobacion.nombreMedioPago) : metodoParaAprobacion?.nombreMetodo }}
      </span>
    </div>

    <!-- Texto instructivo -->
    <p class="modal-aprobacion__instruccion">
      {{ (medioParaAprobacion ? 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_INSTRUCCION_APROBACION_MEDIO' : 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_INSTRUCCION_APROBACION_METODO') | translate }}
    </p>

    <!-- Contenedor del soporte documental del registro -->
    <div class="modal-aprobacion__doc-card">
      <div class="modal-aprobacion__doc-izq">
        <div class="modal-aprobacion__doc-icono">
          <i class="fa fa-file-text-o"></i>
        </div>
        <div class="modal-aprobacion__doc-info">
          <span class="modal-aprobacion__doc-titulo">
            {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CERTIFICADO_REGISTRO' | translate }}
          </span>
          <span class="modal-aprobacion__doc-subtitulo">
            {{ medioParaAprobacion ? (medioParaAprobacion.nombreMedio || medioParaAprobacion.nombreMedioPago) : metodoParaAprobacion?.nombreMetodo }}
          </span>
        </div>
      </div>

      <div class="modal-aprobacion__doc-der">
        <!-- Estado del documento: Pendiente (naranja) o Cargado (verde) -->
        <span class="modal-aprobacion__badge-doc"
              [ngClass]="esCertificadoCargado() ? 'badge-doc-cargado' : 'badge-doc-pendiente'">
          {{ estadoCertificado() }}
        </span>

        <!-- Botón con icono de clip con fondo verde tenue -->
        <div class="modal-aprobacion__clip-wrapper" [hidden]="estaCargandoAdjunto(certificadoParaAprobacion)">
          <!-- Si no tiene archivo cargado: p-fileUpload directo para cargar -->
          <div class="file-false" *ngIf="!esCertificadoCargado() && certificadoParaAprobacion">
            <p-fileUpload name="file"
                          url="{{ certificadoParaAprobacion.indicadorTercero ? svcThUrlTercero : svcThUrl }}"
                          [auto]="false"
                          class="upload-avatar"
                          mode="basic"
                          fSize
                          [codigoAdjunto]="certificadoParaAprobacion.codigo"
                          (onBeforeUpload)="onBeforeSendAdjunto($event)"
                          (onValidSelect)="onSelectAdjunto($event.files, certificadoParaAprobacion)"
                          (onUpload)="onUploadAdjuntoModal($event, certificadoParaAprobacion)">
            </p-fileUpload>
            <button type="button" class="btn-clip-verde"
                    title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_ADJUNTAR' | translate }}">
              <i class="fa fa-paperclip"></i>
            </button>
          </div>

          <!-- Si ya está cargado: abre el visor (donde puede visualizar, descargar o actualizar) -->
          <button *ngIf="esCertificadoCargado()" type="button" class="btn-clip-verde"
                  title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_GESTIONAR_ADJUNTO' | translate }}"
                  (click)="verAdjunto(certificadoParaAprobacion)">
            <i class="fa fa-paperclip"></i>
          </button>
        </div>

        <div [hidden]="!estaCargandoAdjunto(certificadoParaAprobacion)">
          <i class="fa fa-refresh fa-spin fa-fw text-verde"></i>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-aprobacion__footer">
      <ng-container *ngIf="medioParaAprobacion">
        <button type="button" class="btn-aprobacion-accion btn-rechazar"
                [disabled]="guardandoAprobacion"
                (click)="rechazarMedio()">
          <i class="fa fa-times-circle"></i>
          <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_RECHAZAR' | translate }}</span>
        </button>

        <button type="button" class="btn-aprobacion-accion btn-aprobar"
                [disabled]="!esCertificadoCargado() || guardandoAprobacion"
                (click)="aprobarMedio()">
          <i class="{{ guardandoAprobacion ? 'fa fa-refresh fa-spin fa-fw' : 'fa fa-check-circle' }}"></i>
          <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_APROBAR' | translate }}</span>
        </button>
      </ng-container>

      <ng-container *ngIf="!medioParaAprobacion && metodoParaAprobacion">
        <button type="button" class="btn-aprobacion-accion btn-rechazar"
                [disabled]="guardandoAprobacion"
                (click)="cerrarModalAprobacion()">
          <i class="fa fa-times-circle"></i>
          <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_CANCELAR' | translate }}</span>
        </button>

        <button type="button" class="btn-aprobacion-accion btn-aprobar"
                [disabled]="!esCertificadoCargado() || guardandoAprobacion"
                (click)="aprobarMetodo()">
          <i class="{{ guardandoAprobacion ? 'fa fa-refresh fa-spin fa-fw' : 'fa fa-check-circle' }}"></i>
          <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.BTN_APROBAR' | translate }}</span>
        </button>
      </ng-container>
    </div>
  </ng-template>
</p-dialog>

<!-- Modal Bloquear (HU #5352) -->
<p-dialog *ngIf="mostrarModalBloqueo" [(visible)]="mostrarModalBloqueo" [modal]="true" [closable]="true" [draggable]="false"
          [style]="{width: '520px'}" [breakpoints]="{'768px': '92vw'}" styleClass="ds-dialog modal-bloqueo-arbol"
          [closeOnEscape]="true" (onHide)="cerrarModalBloqueo()">

  <ng-template pTemplate="header">
    <span class="modal-bloqueo__titulo">
      {{ tituloModalBloqueo }}
    </span>
  </ng-template>

  <div class="modal-bloqueo__contenido">
    <!-- Causal -->
    <div class="div-form">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <label class="modal-bloqueo__label mb-0">
          *{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CAUSAL' | translate }}
        </label>
        <span *ngIf="cargandoCausalesBloqueo" class="text-muted small">
          <i class="fa fa-refresh fa-spin fa-fw"></i> {{ 'LBL_CARGANDO' | translate }}
        </span>
      </div>

      <p-dropdown [options]="causalesBloqueoOpciones"
                  optionLabel="label"
                  optionValue="value"
                  [(ngModel)]="idCausalBloqueoSeleccionada"
                  placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                  [style]="{'width':'100%'}"
                  [disabled]="cargandoCausalesBloqueo || causalesBloqueoOpciones.length === 0"
                  styleClass="w-100 {{ submittedBloqueo && !idCausalBloqueoSeleccionada ? 'ng-invalid ng-dirty' : '' }}">
      </p-dropdown>

      <div class="p-message p-messages-error p-corner-all" *ngIf="submittedBloqueo && !idCausalBloqueoSeleccionada && causalesBloqueoOpciones.length > 0">
        {{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_CAUSAL_REQUERIDO' | translate }}
      </div>

      <!-- Alerta cuando el servicio no respondió o no hay causales disponibles -->
      <div class="modal-bloqueo__alerta-servicio" *ngIf="!cargandoCausalesBloqueo && causalesBloqueoOpciones.length === 0">
        <div class="modal-bloqueo__alerta-texto">
          <i class="fa fa-exclamation-triangle text-warning mr-1"></i>
          <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_ERROR_CAUSALES_NO_DISPONIBLES' | translate }}</span>
        </div>
        <button type="button" class="btn-bloqueo-reintentar" (click)="cargarCausalesBloqueo()" title="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_REINTENTAR' | translate }}">
          <i class="fa fa-refresh"></i>
          <span>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_REINTENTAR' | translate }}</span>
        </button>
      </div>
    </div>

    <!-- Comentarios -->
    <div class="div-form">
      <label class="modal-bloqueo__label">
        *{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_COMENTARIOS' | translate }}
      </label>
      <textarea rows="4"
                class="form-control modal-bloqueo__textarea {{ submittedBloqueo && (!comentarioBloqueo || !comentarioBloqueo.trim()) ? 'is-invalid' : '' }}"
                [(ngModel)]="comentarioBloqueo"
                maxlength="500"
                placeholder="{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_COMENTARIOS' | translate }}">
      </textarea>
      <div class="modal-bloqueo__char-row">
        <div class="p-message p-messages-error p-corner-all mb-0" *ngIf="submittedBloqueo && (!comentarioBloqueo || !comentarioBloqueo.trim())">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_COMENTARIOS_REQUERIDO' | translate }}
        </div>
        <span class="modal-bloqueo__contador">
          {{ comentarioBloqueo ? comentarioBloqueo.length : 0 }}/500
        </span>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-bloqueo__footer">
      <button type="button" class="btn-bloqueo-accion btn-bloqueo-cancelar"
              [disabled]="guardandoBloqueo"
              (click)="cerrarModalBloqueo()">
        <span>{{ 'BTN_CANCELAR' | translate }}</span>
      </button>

      <button type="button" class="btn-bloqueo-accion btn-bloqueo-guardar"
              [disabled]="guardandoBloqueo || cargandoCausalesBloqueo || causalesBloqueoOpciones.length === 0"
              (click)="guardarBloqueo()">
        <i class="{{ guardandoBloqueo ? 'fa fa-refresh fa-spin fa-fw' : 'fa fa-check' }}"></i>
        <span>{{ 'BTN_GUARDAR' | translate }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- ========================================================================= -->
<!-- SIDEBAR: GESTIONAR TARIFAS PREFERENCIALES (HU #5353)                     -->
<!-- ========================================================================= -->
<app-admsb-tarifas [(visible)]="mostrarSidebarTarifas"
                   [medio]="medioTarifasSeleccionado"
                   [metodo]="metodoTarifasSeleccionado"
                   [idTitular]="idTitular"
                   (guardado)="onTarifaGuardada($event)">
</app-admsb-tarifas>


